var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShareHover = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5206\u4EAB\u9009\u4E2D2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5206\\u4EAB\\u9009\\u4E2D2",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fillOpacity: 0.4,
    cx: 7.5,
    cy: 10.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5206\\u4EAB-(2)-2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5206\\u4EAB-(2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2,2.24 C11.2,1.62144108 10.6985589,1.12 10.08,1.12 C9.46144108,1.12 8.96,1.62144108 8.96,2.24 C8.96,2.85855892 9.46144108,3.36 10.08,3.36 C10.6985589,3.36 11.2,2.85855892 11.2,2.24 Z M12.32,2.24 C12.32,3.47711784 11.3171178,4.48 10.08,4.48 C8.84288216,4.48 7.84,3.47711784 7.84,2.24 C7.84,1.00288216 8.84288216,0 10.08,0 C11.3171178,0 12.32,1.00288216 12.32,2.24 Z M3.36,6.72 C3.36,6.10144108 2.85855892,5.6 2.24,5.6 C1.62144108,5.6 1.12,6.10144108 1.12,6.72 C1.12,7.33855892 1.62144108,7.84 2.24,7.84 C2.85855892,7.84 3.36,7.33855892 3.36,6.72 Z M4.48,6.72 C4.48,7.95711784 3.47711784,8.96 2.24,8.96 C1.00288216,8.96 0,7.95711784 0,6.72 C0,5.48288216 1.00288216,4.48 2.24,4.48 C2.83408494,4.48 3.4038377,4.71599932 3.82391919,5.13608081 C4.24400068,5.5561623 4.48,6.12591506 4.48,6.72 Z M12.88,11.2 C12.88,10.2721616 12.1278384,9.52 11.2,9.52 C10.2721616,9.52 9.52,10.2721616 9.52,11.2 C9.52,12.1278384 10.2721616,12.88 11.2,12.88 C12.1278384,12.88 12.88,12.1278384 12.88,11.2 Z M14,11.2 C14,12.7463973 12.7463973,14 11.2,14 C9.6536027,14 8.4,12.7463973 8.4,11.2 C8.4,9.6536027 9.6536027,8.4 11.2,8.4 C11.9426062,8.4 12.6547971,8.69499915 13.179899,9.22010101 C13.7050008,9.74520287 14,10.4573938 14,11.2 L14,11.2 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82078787,6.37583574 C3.64684812,6.48598248 3.42898272,6.48450752 3.25640391,6.37201484 C3.0838251,6.25952216 2.98551785,6.05490514 3.00173734,5.84195104 C3.01795684,5.62899694 3.14597898,5.44347185 3.33338083,5.36134519 L7.66588783,3.08159114 C7.83982757,2.9714444 8.05769298,2.97291936 8.23027179,3.08541204 C8.4028506,3.19790472 8.50115785,3.40252174 8.48493836,3.61547584 C8.46871886,3.82842994 8.34069672,4.01395503 8.15329487,4.09608169 L3.82078787,6.37583574 Z M3.31171829,8.07425251 C3.05150375,7.91686833 2.96179128,7.56728522 3.11133987,7.29343676 C3.26088846,7.01958831 3.59306711,6.92517534 3.85328167,7.0825595 L8.72735205,9.93225206 C8.89568136,10.0340618 8.99961336,10.2226456 8.99999894,10.4269659 C9.00038237,10.6312862 8.89716097,10.8203019 8.72921617,10.9228124 C8.56127137,11.025323 8.35411798,11.0257548 8.18578867,10.9239451 L3.31171829,8.07425251 Z",
    id: "\\u5F62\\u72B6"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShareHover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share_hover.9bb2185aa233feb73f6d92e495443df2.svg";